<template>
    <div
        class="m-product m-product--featured"
        draggable
        @dragstart="startDrag($event)"
        @click.stop="
            ;[
                isMobile
                    ? [openProductModal(product), (isActive = true)]
                    : isActive = true,
            ]
        "
    >
        <div class="m-product__drag"></div>
        <figure class="m-product__image">
            <img
                v-if="product.image_url"
                :src="`${apiUrl}${product.image_url}`"
                alt=""
                class="m-product__imageImg"
            />
            <img
                v-else
                src="@/assets/pack.jpg"
                alt=""
                class="m-product__imageImg"
            />
        </figure>
        <div class="m-product__textWrapper">
            <p v-if="!isActive" class="m-product__title">
                <span v-if="product.desc_html" class="a-tooltip__icon">
                    <svg
                        width="12"
                        height="12"
                        viewBox="0 0 7 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g clip-path="url(#clip0)" fill="#fff">
                            <path
                                d="M0 6.614c.207-.394.276-.772.483-.854 1.103-.443 2.224-.886 3.465-.64 1.259.247 1.914 1.018 1.724 2.216-.19 1.149-.551 2.265-.827 3.397-.12.509-.293 1.001-.38 1.51-.19 1.132.294 1.559 1.5 1.362.225-.033.449-.082.673-.115.069.05.12.115.19.164-.259.263-.466.624-.776.772-.983.443-2.018.755-3.138.508-1.259-.279-1.948-1.017-1.759-2.215.207-1.28.604-2.527.931-3.791.104-.443.242-.903.293-1.346.087-.935-.362-1.296-1.345-1.149-.275.033-.551.082-1.034.18zM5.172 0C6.26.05 7.07.87 7 1.855c-.069.968-.966 1.657-2.069 1.608-1.034-.05-1.862-.837-1.845-1.773C3.121.706 4.052-.05 5.172 0z"
                            ></path>
                        </g>
                        <defs>
                            <clipPath id="clip0">
                                <path d="M0 0h7v15H0V0z" fill="#fff"></path>
                            </clipPath>
                        </defs>
                    </svg>
                </span>
                <span
                    v-if="product.desc_html"
                    class="a-tooltip__popup a-tooltip__popup--related"
                    v-html="product.desc_html"
                ></span>
                {{ product.name }}
            </p>
            <div class="m-product__data">
                <p v-if="packagePrice && !isActive" class="m-product__price">
                    {{ packagePrice.toPLN() }}
                </p>
            </div>
            <div v-if="isActive" class="m-product__actions">
                <div class="m-product__actionsControls">
                    <span
                        class="material-icons m-product__subtract"
                        @click="amount > 0 ? subtract() : false"
                        >remove</span
                    >
                    <span>{{ amount }} szt.</span>
                    <span class="material-icons m-product__add" @click="add"
                        >add</span
                    >
                </div>
                <select class="m-product__actionsSelect" v-model="dayInWeek">
                    <option
                        v-for="day in availableDays"
                        v-bind:key="day.value"
                        :value="day.value"
                        >{{ day.name }}</option
                    >
                </select>
            </div>
        </div>
        <button @click.stop="isActive = !isActive" class="m-product__relatedAdd">
            <svg
                v-if="isMobile"
                width="52"
                height="52"
                viewBox="0 0 52 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g filter="url(#filter0_d)">
                    <circle
                        cx="26"
                        cy="26"
                        r="16"
                        :fill="amount > 0 && dayInWeek ? '#5DA538' : '#fff'"
                    />
                </g>
                <path
                    d="M20 26.6L24.4667 31.1333L32.4 21"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <defs>
                    <filter
                        id="filter0_d"
                        x="0"
                        y="0"
                        width="52"
                        height="52"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB"
                    >
                        <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                        />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        />
                        <feOffset />
                        <feGaussianBlur stdDeviation="5" />
                        <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0.321569 0 0 0 0 0.392157 0 0 0 0.15 0"
                        />
                        <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow"
                        />
                        <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow"
                            result="shape"
                        />
                    </filter>
                </defs>
            </svg>
            <svg
                v-else
                width="80"
                height="80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <defs>
                    <linearGradient
                        id="linear"
                        x1="0%"
                        y1="0%"
                        x2="0%"
                        y2="100%"
                    >
                        <stop offset="0%" stop-color="#50913B" />
                        <stop offset="100%" stop-color="#5DA538" />
                    </linearGradient>
                </defs>
                <circle
                    cx="31"
                    cy="31"
                    r="20"
                    :fill="isActive ? '#A9C62C' : '#116534'"
                    stroke="url(#linear)"
                    stroke-width="8"
                />
                <path
                    d="M31.2 26.2v10m-5-5h10"
                    stroke="#fff"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </button>
        <div
            v-if="isActive && isMobile"
            class="m-product__modal"
            @click.stop.self="closeProductModal"
        >
            <div class="m-product__modalContent">
                <figure class="m-product__image">
                    <img
                        v-if="activeProduct.image_url"
                        :src="`${apiUrl}${activeProduct.image_url}`"
                        alt=""
                        class="m-product__imageImg"
                    />
                    <img
                        v-else
                        src="@/assets/pack.jpg"
                        alt=""
                        class="m-product__imageImg"
                    />
                </figure>
                <p class="a-text m-product__title">{{ activeProduct.name }}</p>
                <div class="m-product__data">
                    <p v-if="packagePrice && isActive" class="m-product__price">
                        {{ packagePrice.toPLN() }}
                    </p>
                    <div class="m-product__actions">
                        <div class="m-product__actionsControls">
                            <span
                                class="material-icons m-product__subtract"
                                @click="amount > 0 ? subtract() : false"
                                >remove</span
                            >
                            <span>{{ amount }} szt.</span>
                            <span
                                class="material-icons m-product__add"
                                @click="add"
                                >add</span
                            >
                        </div>
                        <select
                            class="m-product__actionsSelect"
                            v-model="dayInWeek"
                        >
                            <option
                                v-for="day in availableDays"
                                v-bind:key="day.value"
                                :value="day.value"
                                >{{ day.name }}</option
                            >
                        </select>
                    </div>
                </div>
                <button
                    class="a-button m-product__button"
                    @click.stop="closeProductModal"
                >
                    Zamknij
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dayInWeek: 0,
            isActive: false,
            activeProduct: {},
            isMobile: false
        }
    },
    props: {
        product: {
            type: Object,
            required: true
        },
        addressId: {
            type: Number,
            required: true
        }
    },
    watch: {
        currentAddressId() {
            this.isActive = false
        }
    },
    computed: {
        apiUrl() {
            return `${process.env.VUE_APP_API}b2b/v1`
        },
        amount() {
            return this.weekDayOrder ? this.weekDayOrder.amount : 0
        },
        weekDayOrder() {
            return this.$store.getters
                .weekDayOrder(this.dayInWeek, this.addressId)
                .find(item => item.product.id === this.product.id)
        },
        packagePrice() {
            return this.$store.getters.packagePriceWithoutDiscount(
                this.product.id,
                this.addressId
            )
        },
        availableDays() {
            return this.$store.getters
                .customerAddressField(this.addressId, 'supportedDays')
                .filter(day => day.is_active === true)
                .map(day => {
                    const dayId = day.day - 1
                    return {
                        name: dayId.toDay(),
                        value: dayId
                    }
                })
        },
        currentAddressId() {
            return this.$store.getters.currentAddressId
        }
    },
    methods: {
        checkIfMobile() {
            if (window.innerWidth < 1024) {
                this.isMobile = true
            } else {
                this.isMobile = false
            }
        },
        isDayDisabled(dayInWeek) {
            if (
                typeof this.availibleDays === 'object' &&
                Object.keys(this.availibleDays).length > 0
            ) {
                return !this.availibleDays.find(
                    item => item.day === dayInWeek + 1
                ).is_active
            } else {
                return false
            }
        },
        openProductModal(item) {
            this.activeProduct = item
        },
        closeProductModal() {
            this.isActive = false
        },
        add() {
            this.$store.dispatch('applyProductToCart', {
                dayInWeek: this.dayInWeek,
                addressId: this.addressId,
                product: this.product,
                amount: this.amount + 1
            })
        },
        subtract() {
            this.$store.dispatch('applyProductToCart', {
                dayInWeek: this.dayInWeek,
                addressId: this.addressId,
                product: this.product,
                amount: this.amount - 1
            })
        },
        remove() {
            this.$store.dispatch('applyProductToCart', {
                dayInWeek: this.dayInWeek,
                addressId: this.addressId,
                product: this.product,
                amount: 0
            })
        },
        openModalRemoveProduct() {
            this.$store.dispatch('modalShow', {
                name: 'productRemove',
                payload: {
                    dayInWeek: this.dayInWeek,
                    addressId: this.addressId,
                    product: this.product
                }
            })
        },
        startDrag(evt) {
            evt.dataTransfer.dropEffect = 'move'
            evt.dataTransfer.effectAllowed = 'move'
            evt.dataTransfer.setData('productId', this.product.id)
        }
    },
    mounted() {
        this.checkIfMobile()
    },
    created() {
        if (this.availableDays.length > 0) {
            this.dayInWeek = this.availableDays[0].value
        }
    }
}
</script>
